import { openModal } from '@core/components/ModalStack';
import { ImageFinderModalProps } from './ImageFinderModal';

export async function openImageFinderModal(props: ImageFinderModalProps) {
  const { ImageFinderModal } = await import('./ImageFinderModal');

  openModal(ImageFinderModal, props);
}
